import $ from 'jquery';

export const carousel = {
  init() {
    const self = this;
    const autoRotateLength = 10000;

    $(document).ready(() => {

      $('.carousel').each(function() {

        // Auto-generate thumbnails as necessary on document load
        const slides = $(this).find('.carousel-slide');
        const numberOfSlides = slides.length;

        let htmlToInsert = '';

        for (let i = 1; i <= numberOfSlides; i++) {
          htmlToInsert += '<div class="carousel-thumbnail"></div>';
        }

        $(this).find('.carousel-thumbnails-autopopulate').html(htmlToInsert);

        self.adjustCarouselForDesktop($(this));

        // Set position to the first slide at document load
        self.setSlidePositions($(this), 0);

      });

      // Start an auto-rotate timer
      const timer = new self.Timer((() => {
        $('.carousel').each(function() {
          if ($(this).data('autorotate')) {
            self.nextSlide($(this), true);
          }
        });
      }), autoRotateLength);

      // If a thumbnail is clicked, go to the proper slide
      $('.carousel-thumbnail').click(function() {

        timer.reset(autoRotateLength);

        const position = $(this).index();
        const carousel = $(this).parent().parent()
.parent();
        self.setSlidePositions(carousel, position);
      });

      // If the carousel is swiped on mobile, go to the next or previous slide
      $('.carousel').on('touchstart', function(event) {
        const xStart = event.originalEvent.touches[0].pageX;
        const yStart = event.originalEvent.touches[0].pageY;
        const carousel = $(this);
        $(this).one('touchmove', (event) => {
          const xEnd = event.originalEvent.touches[0].pageX;
          const yEnd = event.originalEvent.touches[0].pageY;
          const xMove = xStart - xEnd;
          const yMove = yStart - yEnd;

          // If x movement is positive and greater in magnitude than Y movement
          if ((xMove > 5) && (Math.abs(xMove) > Math.abs(yMove))) {

            timer.reset(autoRotateLength);

            self.nextSlide(carousel);
          } else if ((xMove < -5) && (Math.abs(xMove) > Math.abs(yMove))) {

            timer.reset(autoRotateLength);
            self.previousSlide(carousel);
          }
        });
        $('.carousel').on('touchend', function() {
          $(this).off('touchmove');
        });
      });

      // If a slide is clicked, go to that slide
      $('.carousel-slide').click(function() {

        timer.reset(autoRotateLength);

        const carousel = $(this).parent().parent();
        const position = $(this).index();
        self.setSlidePositions(carousel, position);
      });

      setTimeout(() => {
        $('.carousel .carousel-slide').addClass('carousel-slide-transition');
      }, 500);
    });

    // Create a variable to store the width of the window
    let windowWidth = $(window).width();

    // When the window is resized, set slide positions to 0 for desktop-adjustable carousels.
    $(window).on('resize', () => {

      // If the window width has changed
      if (windowWidth != $(window).width()) {

        // Store new window width
        windowWidth = $(window).width();

        $('.carousel').each(function() {

          // If the carousel is adjusted for desktop
          if ($(this).data('adjust-for-desktop')) {

            self.adjustCarouselForDesktop($(this));

            // Set position to the first slide at document load
            self.setSlidePositions($(this), 0);
          }

        });
      }
    });
  },

  Timer: function(fn, t) {
    let timerObj = setInterval(fn, t);

    this.stop = function() {
      if (timerObj) {
        clearInterval(timerObj);
        timerObj = null;
      }
      return this;
    };

    // start timer using current settings (if it's not already running)
    this.start = function() {
      if (!timerObj) {
        this.stop();
        timerObj = setInterval(fn, t);
      }
      return this;
    };

    // start with new or original interval, stop current interval
    this.reset = function(newT = t) {
      t = newT;
      return this.stop().start();
    };
  },

  setSlidePositions(carousel, position = 0) {
    const currentThumbnail = carousel.find('.carousel-thumbnail').eq(position);
    const lastSlideIndex = carousel.find('.carousel-slide').length - 1;

    // If there is no scrolling in this carousel due to the browser size, shift positions to halfway through
    if (carousel.data('no-scroll')) {
      this.shiftToPosition(carousel, Math.floor(lastSlideIndex / 2), lastSlideIndex % 2 != 0);
      return;
    }

    // If the current thumbnail is hidden, we need to check to see whether we are on the last slide
    if (currentThumbnail.is(':hidden')) {

      // If we are on the last slide - do nothing
      if (position == lastSlideIndex) {


      // If we are not on the last slide, set the slide positions to the next available slide
      } else {
        this.setSlidePositions(carousel, position + 1);
      }

    } else {

      // If the thumbnail is not hidden, shift to that position
      this.shiftToPosition(carousel, position, false);
    }
  },

  shiftToPosition(carousel, position = 0, halfway = false) {

    const slides = carousel.find('.carousel-slide');
    const currentSlide = carousel.find('.carousel-slide').eq(position);
    const currentThumbnail = carousel.find('.carousel-thumbnail').eq(position);
    const offsetPerSlide = carousel.data('offset-amount');

    slides.each(function(index) {
      var offset = 0;
      if (halfway) {
        var offset = (index - position - 0.5) * offsetPerSlide;
      } else {
        var offset = (index - position) * offsetPerSlide;
      }
      $(this).css('transform', `translateX(${offset}%)`);
    });

    // Remove selected class from all slides
    carousel.find('.carousel-slide').removeClass('carousel-slide-selected');

    // Add selected class to slide with given position
    currentSlide.addClass('carousel-slide-selected');

    // Remove selected class from all thumbnails
    carousel.find('.carousel-thumbnail').removeClass('carousel-thumbnail-selected');

    // Add selected class to thumbnail with given position
    currentThumbnail.addClass('carousel-thumbnail-selected');

    // Change logo to light if this slide has a logo override
    if (currentSlide.data('override-mobile-logo-light')) {
      $('#navigation').addClass('override-mobile-logo-light');
    } else {
      $('#navigation').removeClass('override-mobile-logo-light');
    }

    // Change right desktop nav to light if this slide has a right desktop nav override
    if (currentSlide.data('override-desktop-rightnav-light')) {
      $('#navigation').addClass('override-desktop-rightnav-light');
    } else {
      $('#navigation').removeClass('override-desktop-rightnav-light');
    }
  },

  previousSlide(carousel, rotate = false) {
    const selectedSlide = carousel.find('.carousel-slide-selected').index();
    const lastSlideIndex = carousel.find('.carousel-slide').length - 1;
    if ((selectedSlide == 0) & rotate) {
      this.setSlidePositions(carousel, lastSlideIndex - 1);
    } else if (selectedSlide != 0) {
      this.setSlidePositions(carousel, selectedSlide - 1);
    }

  },

  nextSlide(carousel, rotate = false) {
    const selectedSlide = carousel.find('.carousel-slide-selected').index();
    const lastSlideIndex = carousel.find('.carousel-slide').length - 1;
    if ((selectedSlide == lastSlideIndex) & rotate) {
      this.setSlidePositions(carousel, 0);
    } else if (selectedSlide != lastSlideIndex) {
      this.setSlidePositions(carousel, selectedSlide + 1);
    }

  },

  reset(carousel) {
    this.setSlidePositions(carousel, 0);
  },

  adjustCarouselForDesktop(carousel) {

    if (carousel.data('adjust-for-desktop')) {

      // Make adjustments for desktop
      const offsetPerSlide = carousel.data('offset-amount');
      const browserWidth = $(window).width();
      const slideWidth = carousel.find('.carousel-slide').width();
      const slidesPerPage = Math.floor(browserWidth / ((slideWidth * offsetPerSlide / 100) - 0.5));
      const adjustmentFactor = Math.floor((slidesPerPage - 1) / 2);
      const numberOfSlides = carousel.find('.carousel-slide').length;

      carousel.find('.carousel-thumbnail').show();

      // Hide thumbnails
      for (let i = 0; i < adjustmentFactor; i++) {
        carousel.find('.carousel-thumbnail').eq(i).hide();
        carousel.find('.carousel-thumbnail').eq(-(i + 1)).hide();
      }

      if (adjustmentFactor >= (numberOfSlides / 2)) {
        carousel.data('no-scroll', 'true');
      } else {
        carousel.data('no-scroll', '');
      }
    }
  },
};
